import type { SaleBadge } from "@lib/wrappers/algolia/types";

/**
 * Checks if a sale badge should be displayed based on the current date and badge validity period
 * @param hasDiscount - Indicates if the product has a discount
 * @param saleBadge - The sale badge information
 * @returns The sale badge if it's valid and within the time period, undefined otherwise
 */
export const getValidSaleBadge = <T extends SaleBadge>(saleBadge?: T | null): T | undefined => {
    if (!saleBadge) {
        return undefined;
    }

    const now = new Date();
    const from = new Date(saleBadge.from);
    const until = new Date(saleBadge.until);

    return now >= from && now <= until ? saleBadge : undefined;
};

const BLACK_FRIDAY_BADGE = "blackfriday";

export const isBlackFridayBadge = (saleBadge?: SaleBadge | null): boolean =>
    saleBadge?.badge?.toLowerCase() === BLACK_FRIDAY_BADGE;
